export default defineNuxtPlugin(() => {
  return {
    provide: {
      removeUploadcareSrc: (src: string) => {
        const res = src.replaceAll('https://ucarecdn.com/', 'https://storage.yandexcloud.net/leonhotel.net/').replaceAll('//', '/').replaceAll(':/', '://')
        console.log(src + ' -> ' + res)
        return res
      },
    },
  }
})